import axios from "axios";
import Vue from "vue";
import objectUtils from "../../util/objectUtils";
import helper from "../../util/helper";

export default {
  state: () => ({
    selectedKKYCaseModel: {
      customerNumber: null,
      status: null,
      xref: null,
      stationCode: null,
      currency: null,
      documentType: null,
      salesUserId: null,
      approverUserId: null,
      paymentType: null,
      ticketCount: null,
      amount: null,
      salesChannelId: null,
    },
  }),

  mutations: {
    setSelectedKKYCaseModel(state, kkyCaseModel) {
      Vue.set(state, "selectedKKYCaseModel", kkyCaseModel);
    },
    setDefaultKKYAccountTransferModule(state) {
      Vue.set(state, "selectedKKYCaseModel", {
        customerNumber: null,
        status: null,
        xref: null,
        stationCode: null,
        currency: null,
        documentType: null,
        salesUserId: null,
        approverUserId: null,
        paymentType: null,
        ticketCount: null,
        amount: null,
        salesChannelId: null,
      });
    },
  },

  actions: {
    getKKYAccountTransferDetails: (context, request) => {
      return axios
        .post(context.getters.getMcServiceUrl + "/kky-cases", request, {})
        .then((response) => {
          return response;
        })
        .catch((err) => {
          return err.response;
        });
    },
    fiIntegration: (context, request) => {
      return axios.get(context.getters.getMcServiceUrl + "/kky-cases/fi-integration/" + request, {}).then((response) => {
        return response.data;
      });
    },
    sendToKKY: (context, request) => {
      return axios
        .post(context.getters.getMcServiceUrl + "/kky-/send-to-KKY/", request, {})
        .then((response) => {
          return response;
        })
        .catch((err) => {
          return err.response;
        });
    },
  },
  getters: {
    getSelectedKKYCaseModel: (state) => {
      return state.selectedKKYCaseModel;
    },
  },
};
